import { memo } from "react";

import InputRange from "./InputRange";

function ChangeValue({
  data,
  setData,
  transport_name,
  handleChangeTransportName,
  handleUpdatedData,
  handleInitial,
}) {
  function handleAccuracy(name, value) {
    let updated = data.accuracy.map((item) => item);

    if (name === "first") {
      updated[0] = Number(value);
    } else {
      updated[1] = Number(value);
    }

    setData({
      ...data,
      accuracy: updated,
    });
  }

  function handlePeakAccuracy(name, value) {
    let updated = data.peak_accuracy.map((item) => item);

    if (name === "first") {
      updated[0] = Number(value);
    } else {
      updated[1] = Number(value);
    }

    setData({
      ...data,
      peak_accuracy: updated,
    });
  }

  function handleMinTemp(name, value) {
    let updated = data.mintemp.map((item) => item);

    if (name === "first") {
      updated[0] = Number(value);
    } else if (name === "second") {
      updated[1] = Number(value);
    } else {
      updated[2] = Number(value);
    }

    setData({
      ...data,
      mintemp: updated,
    });
  }

  function handleMaxTemp(name, value) {
    let updated = data.maxtemp.map((item) => item);

    if (name === "first") {
      updated[0] = Number(value);
    } else if (name === "second") {
      updated[1] = Number(value);
    } else {
      updated[2] = Number(value);
    }

    setData({
      ...data,
      maxtemp: updated,
    });
  }

  function handleMaxPeakTemp(name, value) {
    let updated = data.maxpeaktemp.map((item) => item);

    if (name === "first") {
      updated[0] = Number(value);
    } else if (name === "second") {
      updated[1] = Number(value);
    } else {
      updated[2] = Number(value);
    }

    setData({
      ...data,
      maxpeaktemp: updated,
    });
  }

  return (
    <div className="chat-panel">
      <div className="col">
        <p> Название траспортного средства </p>

        <div className="input-range">
          <div className="input-range-title">ТС:</div>

          <div className="input-range-value">
            <input
              type="text"
              value={transport_name}
              onChange={(event) =>
                handleChangeTransportName(event.target.value)
              }
            />
          </div>
        </div>
      </div>
      <div className="col">
        <p> Кол-во точек в шапке </p>

        <InputRange
          title="Min"
          value={data.accuracy[0]}
          handleChange={(value) => handleAccuracy("first", value)}
          min="0"
          max="50"
        />

        <InputRange
          title="Max"
          value={data.accuracy[1]}
          handleChange={(value) => handleAccuracy("last", value)}
          min="0"
          max="50"
        />
      </div>

      <div className="col">
        <p> Кол-во точек в шапке для пика</p>

        <InputRange
          title="Min"
          value={data.peak_accuracy[0]}
          handleChange={(value) => handlePeakAccuracy("first", value)}
          min="0"
          max="50"
        />

        <InputRange
          title="Max"
          value={data.peak_accuracy[1]}
          handleChange={(value) => handlePeakAccuracy("last", value)}
          min="0"
          max="50"
        />
      </div>

      <div className="col">
        <p> Границы нижней температуры </p>

        <InputRange
          title="Degree"
          value={data.mintemp[0]}
          handleChange={(value) => handleMinTemp("first", value)}
          min="-25"
          max={data.maxtemp[0] - 1}
        />

        <InputRange
          title="Down"
          value={data.mintemp[1]}
          handleChange={(value) => handleMinTemp("second", value)}
          min="0"
          max="3"
          step="0.01"
        />

        <InputRange
          title="Up"
          value={data.mintemp[2]}
          handleChange={(value) => handleMinTemp("last", value)}
          min="0"
          max="3"
          step="0.01"
        />
      </div>

      <div className="col">
        <p> Границы верхней температуры </p>

        <InputRange
          title="Degree"
          value={data.maxtemp[0]}
          handleChange={(value) => handleMaxTemp("first", value)}
          min={data.mintemp[0] + 1}
          max="30"
        />

        <InputRange
          title="Down"
          value={data.maxtemp[1]}
          handleChange={(value) => handleMaxTemp("second", value)}
          min="0"
          max="3"
          step="0.01"
        />

        <InputRange
          title="Up"
          value={data.maxtemp[2]}
          handleChange={(value) => handleMaxTemp("last", value)}
          min="0"
          max="3"
          step="0.01"
        />
      </div>

      <div className="col">
        <p> Границы температуры для пика</p>

        <InputRange
          title="Degree"
          value={data.maxpeaktemp[0]}
          handleChange={(value) => handleMaxPeakTemp("first", value)}
          min="0"
          max="50"
        />

        <InputRange
          title="Down"
          value={data.maxpeaktemp[1]}
          handleChange={(value) => handleMaxPeakTemp("second", value)}
          min="0"
          max="5"
          step="0.01"
        />

        <InputRange
          title="Up"
          value={data.maxpeaktemp[2]}
          handleChange={(value) => handleMaxPeakTemp("last", value)}
          min="0"
          max="5"
          step="0.01"
        />
      </div>

      <div className="col">
        <p> Рандом кофициент</p>

        <InputRange
          title="Val"
          value={data.random_coefficient}
          handleChange={(value) =>
            setData({ ...data, random_coefficient: value })
          }
          min="0"
          max="1"
          step="0.1"
        />
      </div>

      <div className="col">
        <p> Период в минутах</p>

        <InputRange
          title="Val"
          value={data.period}
          handleChange={(value) => setData({ ...data, period: value })}
          min="0"
          max="60"
        />
      </div>

      <div className="col">
        <p> Время начала</p>

        <input
          type="datetime-local"
          value={data.start_time}
          onChange={(event) =>
            setData({ ...data, start_time: event.target.value })
          }
        />
      </div>

      <div className="col">
        <p> Время окончания</p>

        <input
          type="datetime-local"
          value={data.stop_time}
          onChange={(event) =>
            setData({ ...data, stop_time: event.target.value })
          }
        />
      </div>

      <div className="row right settings-chat-button">
        <button onClick={() => handleInitial()}>Изначальные значения</button>

        <button onClick={() => handleUpdatedData()}>Обновить</button>
      </div>
    </div>
  );
}

export default memo(ChangeValue);
